import { Subscription } from "types/Models/subscription";
import Modal from "./DesignSystem/Modal/Modal";
import { TaxSubscriptionsListContent } from "pages/Tax/TaxSubscriptionModalContent";
import { CheckoutModal } from "./CheckoutModal/CheckoutModal";
import { useModal } from "hooks/useModal";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";

type TaxSoftwareSubscriptionsModalProps = {
  open: boolean;
  onClose: () => void;
  subscriptionPlans?: Subscription;
  onProductSubscribe?: () => void;
};

export const TaxSoftwareSubscriptionsModal = ({
  open,
  onClose,
  subscriptionPlans,
  onProductSubscribe,
}: TaxSoftwareSubscriptionsModalProps) => {
  const checkoutModal = useModal();
  const entityId = useCurrentEntityId();
  const onSubscribed = () => {
    checkoutModal.close();
    onClose();
    onProductSubscribe?.();
  };

  return (
    <Modal.Root open={open} onOpenChange={onClose}>
      <Modal.Content size="large">
        <Modal.Header>
          <div className="t-w-full">
            <Modal.Title titleIcon={<Modal.Close />}>
              <div>Upgrade Your Plan </div>
            </Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div>
            <TaxSubscriptionsListContent
              price={subscriptionPlans?.amount}
              type={subscriptionPlans?.subscription_name}
              features={subscriptionPlans?.metadata?.comparison || []}
              description={
                subscriptionPlans?.metadata?.service_description || ""
              }
              onUpgrade={() => {
                checkoutModal.open();
              }}
              isFreePlanActive={!subscriptionPlans?.group_subscription}
            />
            {subscriptionPlans && entityId && (
              <CheckoutModal
                entityId={entityId}
                type="subscription"
                onClose={checkoutModal.close}
                open={checkoutModal.isOpen}
                subscription={subscriptionPlans!}
                onSubscribed={onSubscribed}
              />
            )}
          </div>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
